import { AXOVA_GLOBALS } from './environment.axova.globals';

export const environment = AXOVA_GLOBALS;

// Overwrite settings for this environment.
environment.name = 'test';
environment.apiConfiguration.baseUrl = 'https://test-api.axova.cloud';
environment.apiConfiguration.publicApiKey = '7002b21fc8c2a675afd034ec2273ce70375dd83a';
environment.appUrls.workOffice = 'https://test-v5.axova.cloud';
environment.appUrls.workOfficeV4 = 'https://test-office.axova.cloud';
environment.appUrls.app = 'https://test-app.axova.cloud';
environment.appUrls.website = 'https://test-www.axova.cloud';
environment.appUrls.freigabe = 'https://test-freigabe.axova.cloud';
environment.legalUrls.imprint = 'https://test-www.axova.cloud/impressum';
environment.legalUrls.privacy = 'https://test-www.axova.cloud/datenschutz';
environment.appUrls.files = 'https://test-files.axova.cloud';
environment.appUrls.appointmentScheduler = 'https://test-termin.axova.cloud';
environment.isLoggingEnabled.ngxs = true;
environment.isLoggingEnabled.logger = true;
environment.production = false;
environment.sentryDsn.app = 'https://a9d699a606df4f8f93cefbc00d94fb1b@bugs.digitalemenschen.dev/19';
environment.sentryDsn.office = 'https://e79e1de6db8a4be392dd94094d85cd39@bugs.digitalemenschen.dev/11';
environment.sentryDsn.website = 'https://49cc5c9d80a34bea989292e6912f9f41@bugs.digitalemenschen.dev/7';
environment.sentryDsn.screen = 'https://49cc5c9d80a34bea989292e6912f9f41@bugs.digitalemenschen.dev/7';
environment.googleMapApiKey = 'AIzaSyCz_WQ13DUqgawY2kxUejHhbqcJTqMCdB4';
